
import {createSlice} from "@reduxjs/toolkit";

export const contractDetailListSlice = createSlice({
    name: 'contractDetailListSlc',
    initialState: {value: {contractId: null,
            contractName: null,
            dataPointId: 'null',
            csListDrawerState: false,
            csfListDrawerState: false,
            cdpListDrawerState: false,
            cdpvListDrawerState: false,
            cdpvfListDrawerState: false,
            vocabularyListDrawerState: false,
            marketListDrawerState: false
        }},
    reducers:
{
    changeContractDetailList: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContractDetailList } = contractDetailListSlice.actions;

export default  contractDetailListSlice.reducer ;

